/* eslint-disable no-case-declarations */
import * as balancesActions from '../actions/balances';

const defaultState = {
  gettingBalances: true,
};

// eslint-disable-next-line default-param-last
const balances = (state = defaultState, action) => {
  switch (action.type) {
    case balancesActions.GET_BALANCES: {
      const { getBalancesError, balances, ...newState } = state;
      return {
        ...newState,
        gettingBalances: true,
      };
    }
    case balancesActions.GET_BALANCES_SUCCESS:
      return {
        ...state,
        balances: action.payload,
        gettingBalances: false,
      };
    case balancesActions.GET_BALANCES_ERROR:
      return {
        ...state,
        getBalancesError: action.payload,
        gettingBalances: false,
      };
    case balancesActions.ADD_BALANCES: {
      const { addBalancesError, ...newState } = state;
      return {
        ...newState,
        addingBalances: true,
      };
    }
    case balancesActions.ADD_BALANCES_SUCCESS:
      return {
        ...state,
        addingBalances: false,
      };
    case balancesActions.ADD_BALANCES_ERROR:
      return {
        ...state,
        addingBalances: false,
        addBalancesError: action.payload,
      };
    default:
      return state;
  }
};

export default balances;
